// extracted by mini-css-extract-plugin
export default {"mobileNavigationDropdown":"MobileNavigationDropdown_mobileNavigationDropdown__TzOda","navLinks":"MobileNavigationDropdown_navLinks__Nk0xp"};